import CollectionFilterDropdownContent, {
  CollectionFilterDropdownContentProps,
} from "@components/dropdown/collection/CollectionFilterDropdownContent"
import DiscoPaginatedDropdown, {
  DiscoPaginatedDropdownProps,
} from "@disco-ui/dropdown/DiscoPaginatedDropdown"
import { TestIDProps } from "@utils/typeUtils"

type Props = TestIDProps &
  CollectionFilterDropdownContentProps &
  Pick<DiscoPaginatedDropdownProps, "title" | "icon">

function CollectionFilterDropdown({
  testid = "CollectionFilterDropdown",
  title,
  icon,
  ...contentProps
}: Props) {
  return (
    <DiscoPaginatedDropdown
      testid={testid}
      title={title}
      icon={icon}
      content={<CollectionFilterDropdownContent {...contentProps} />}
    />
  )
}

export default CollectionFilterDropdown
